import { createContext } from "react";
import type { OrganisationContextType } from "./OrganisationContext.types";

const OrganisationContext = createContext<OrganisationContextType | undefined>(undefined);
OrganisationContext.displayName = "OrganisationContext";

export default OrganisationContext;
